'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodeQueryParam = exports.generateURL = undefined;

var _buildUrl = require('build-url');

var _buildUrl2 = _interopRequireDefault(_buildUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateURL = exports.generateURL = function generateURL(endPoint, path, params) {
  return (0, _buildUrl2.default)(endPoint, {
    path: path,
    queryParams: params
  });
};

var encodeQueryParam = exports.encodeQueryParam = function encodeQueryParam(queryValue) {
  var regexp = /%20/g;
  return encodeURIComponent(queryValue).replace(regexp, '+');
};